"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.workPlaceBeforeLeaveTypeCustomChoices = exports.lastWeekRemoteWorkDaysCustomChoices = exports.lastWeekTravelToWorkDaysCustomChoices = void 0;
const moment_1 = __importDefault(require("moment"));
const i18n_config_1 = __importDefault(require("evolution-frontend/lib/config/i18n.config"));
const helpers_1 = require("evolution-common/lib/utils/helpers");
const choices_1 = require("../../common/choices");
const helpers_2 = require("evolution-common/lib/services/odSurvey/helpers");
const formatDateWithDowOfWeek = (date) => date.locale(i18n_config_1.default.language).format('dddd LL');
const getDayChoices = (interview) => {
    const assignedDay = (0, helpers_1.getResponse)(interview, '_assignedDay');
    // For day choices, take the assigned day as reference, or take today
    const currentWeekDay = assignedDay ? (0, moment_1.default)(assignedDay) : (0, moment_1.default)();
    const lastMonday = currentWeekDay.subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD');
    return [
        {
            value: 'monday',
            label: (t) => formatDateWithDowOfWeek((0, moment_1.default)(lastMonday))
        },
        {
            value: 'tuesday',
            label: (t) => formatDateWithDowOfWeek((0, moment_1.default)(lastMonday).add(1, 'day'))
        },
        {
            value: 'wednesday',
            label: (t) => formatDateWithDowOfWeek((0, moment_1.default)(lastMonday).add(2, 'day'))
        },
        {
            value: 'thursday',
            label: (t) => formatDateWithDowOfWeek((0, moment_1.default)(lastMonday).add(3, 'day'))
        },
        {
            value: 'friday',
            label: (t) => formatDateWithDowOfWeek((0, moment_1.default)(lastMonday).add(4, 'day'))
        },
        {
            value: 'saturday',
            label: (t) => formatDateWithDowOfWeek((0, moment_1.default)(lastMonday).add(5, 'day'))
        },
        {
            value: 'sunday',
            label: (t) => formatDateWithDowOfWeek((0, moment_1.default)(lastMonday).add(6, 'day'))
        }
    ];
};
const lastWeekTravelToWorkDaysCustomChoices = (interview) => [
    ...getDayChoices(interview),
    {
        value: 'no',
        label: {
            fr: 'Pas de déplacement pour le travail cette semaine.',
            en: 'No travel for work this week.'
        }
    },
    ...choices_1.preferNotToAnswer
];
exports.lastWeekTravelToWorkDaysCustomChoices = lastWeekTravelToWorkDaysCustomChoices;
const lastWeekRemoteWorkDaysCustomChoices = (interview) => [
    ...getDayChoices(interview),
    {
        value: 'no',
        label: {
            fr: 'Pas de télétravail cette semaine.',
            en: 'No remote work this week.'
        }
    },
    ...choices_1.preferNotToAnswer
];
exports.lastWeekRemoteWorkDaysCustomChoices = lastWeekRemoteWorkDaysCustomChoices;
// FIXME This is copied from the `workPlaceBeforeLeaveTypeChoices` type in
// choices.tsx. It was copied from there because the choices contain the nickname
exports.workPlaceBeforeLeaveTypeCustomChoices = [
    {
        value: 'onLocation',
        label: (t, interview, path) => {
            const activePerson = (0, helpers_2.getPerson)({ interview, path });
            const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
            return t('household:workPlaceBeforeLeaveTypeChoicesOnLocation', {
                nickname,
                count: (0, helpers_2.countPersons)({ interview })
            });
        }
    },
    {
        value: 'hybrid',
        label: (t, interview, path) => {
            const activePerson = (0, helpers_2.getPerson)({ interview, path });
            const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
            return t('household:workPlaceBeforeLeaveTypeChoicesHybrid', {
                nickname,
                count: (0, helpers_2.countPersons)({ interview })
            });
        }
    },
    {
        value: 'onTheRoadWithUsualPlace',
        label: (t, interview, path) => {
            const activePerson = (0, helpers_2.getPerson)({ interview, path });
            const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
            return t('household:workPlaceBeforeLeaveTypeChoicesOnTheRoadWithUsualPlace', {
                nickname,
                count: (0, helpers_2.countPersons)({ interview })
            });
        }
    },
    {
        value: 'onTheRoadWithoutUsualPlace',
        label: (t, interview, path) => {
            const activePerson = (0, helpers_2.getPerson)({ interview, path });
            const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
            return t('household:workPlaceBeforeLeaveTypeChoicesOnTheRoadWithoutUsualPlace', {
                nickname,
                count: (0, helpers_2.countPersons)({ interview })
            });
        }
    },
    {
        value: 'remote',
        label: (t, interview, path) => {
            const activePerson = (0, helpers_2.getPerson)({ interview, path });
            const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
            return t('household:workPlaceBeforeLeaveTypeChoicesRemote', {
                nickname,
                count: (0, helpers_2.countPersons)({ interview })
            });
        }
    }
];
